<template>
  <header class="bg-white sticky top-0 z-50 shadow-md transition-all duration-300">
    <div class="container mx-auto px-4">
      <!-- 顶部导航 -->
      <div class="flex justify-between items-center py-3 border-b border-neutral-200">
        <div class="flex items-center space-x-4">
          <router-link to="#" class="text-neutral-500 hover:text-primary transition-colors">
            <i class="fa fa-map-marker"></i>
            <span class="text-sm ml-1 hidden md:inline">配送至：北京市</span>
          </router-link>
          <router-link to="#" class="text-neutral-500 hover:text-primary transition-colors hidden md:inline">
            <i class="fa fa-bell-o"></i>
            <span class="text-sm ml-1">通知</span>
          </router-link>
        </div>
        
        <div class="flex items-center space-x-4">
          <router-link to="#" class="text-neutral-500 hover:text-primary transition-colors">
            <i class="fa fa-heart-o"></i>
            <span class="text-sm ml-1 hidden md:inline">收藏夹</span>
          </router-link>
          <router-link to="/login" class="text-neutral-500 hover:text-primary transition-colors">
            <i class="fa fa-user-o"></i>
            <span class="text-sm ml-1">登录/注册</span>
          </router-link>
          <router-link to="#" class="text-neutral-500 hover:text-primary transition-colors">
            <i class="fa fa-globe"></i>
            <span class="text-sm ml-1 hidden md:inline">语言</span>
          </router-link>
        </div>
      </div>
      
      <!-- 主导航 -->
      <div class="flex flex-col md:flex-row justify-between items-center py-4">
        <!-- Logo -->
        <router-link to="/" class="text-2xl font-bold text-primary mb-4 md:mb-0 flex items-center">
          <i class="fa fa-shopping-bag mr-2"></i>
          <span>EliteShop</span>
        </router-link>
        
        <!-- 搜索栏 -->
        <div class="relative w-full md:w-1/2 mb-4 md:mb-0">
          <input type="text" placeholder="搜索商品、品牌或分类..." 
                 class="w-full py-2 px-4 pr-10 rounded-full border border-neutral-200 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all">
          <button class="absolute right-3 top-1/2 transform -translate-y-1/2 text-neutral-400 hover:text-primary transition-colors">
            <i class="fa fa-search"></i>
          </button>
        </div>
        
        <!-- 购物车 -->
        <router-link to="/cart" class="relative flex items-center text-neutral-600 hover:text-primary transition-colors">
          <i class="fa fa-shopping-cart text-xl"></i>
          <span class="ml-2 hidden md:inline">购物车</span>
          <span class="absolute -top-2 -right-2 bg-secondary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {{ cartCount }}
          </span>
        </router-link>
      </div>
      
      <!-- 分类导航 -->
      <nav class="py-3 border-t border-neutral-200">
        <ul class="flex flex-wrap justify-center md:justify-start space-x-1 md:space-x-6 text-sm">
          <li><router-link to="/" class="py-2 px-1 hover:text-primary font-medium transition-colors">首页</router-link></li>
          <li><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">电子产品</router-link></li>
          <li><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">服装鞋帽</router-link></li>
          <li><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">家居用品</router-link></li>
          <li><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">美妆个护</router-link></li>
          <li><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">运动户外</router-link></li>
          <li><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">母婴用品</router-link></li>
          <li class="md:hidden"><router-link to="#" class="py-2 px-1 hover:text-primary transition-colors">更多</router-link></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      cartCount: 3 // 购物车商品数量，实际项目中从Vuex获取
    }
  }
}
</script>